import { Component, OnInit } from '@angular/core';
import { VexPopoverRef } from 'src/@vex/components/vex-popover/vex-popover-ref';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserService } from 'src/app/shared/services/user.service';
import { User } from 'src/core/interfaces/user';
import { lastValueFrom } from 'rxjs';
import { Permissions } from 'src/assets/static-data/permissions';


export interface MegaMenuFeature {
  icon: string;
  label: string;
  route: string;
}

export interface MegaMenuPage {
  label: string;
  route: string;
}

@Component({
  selector: 'vex-mega-menu',
  templateUrl: './mega-menu.component.html',
  standalone: true,
  imports: [MatButtonModule, NgFor, RouterLink, MatIconModule,TranslateModule],
})
export class MegaMenuComponent implements OnInit {
  permissions = new Permissions();
  currentUser: User;

  features: MegaMenuFeature[] = [
  ];

  constructor(
    private popoverRef: VexPopoverRef<MegaMenuComponent>,
    private translateService: TranslateService,
    private authService: AuthService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.currentUser = this.authService.currentUserValue;
    this.managePermissions();
  }

  async managePermissions() {
    const permissions = [
      { permission: this.permissions.READ_CUSTOMER, icon: 'mat:person', label: "CUSTOMERS.TEXT", route: 'master-data/customers' },
      { permission: this.permissions.READ_USER, icon: 'mat:person', label: "USERS.TEXT", route: '/user-management/users' },
      { permission: this.permissions.READ_ROLE, icon: 'mat:settings', label: "ROLES.TEXT", route: '/role-management/roles' },
      { permission: this.permissions.READ_VEHICLE, icon: 'mat:local_shipping', label: "VEHICLES.TEXT", route: 'master-data/vehicles' },
      { permission: this.permissions.READ_TRANSPORTER, icon: 'mat:business', label: "TRANSPORTERS.TEXT", route: 'master-data/transporters' },
      { permission: this.permissions.READ_FACTORY, icon: 'mat:map', label: "FACTORIES.TEXT", route: 'master-data/factories' }
    ];

    try {
      const featurePromises = permissions.map(async (perm) => {
        const response = await lastValueFrom(this.userService.checkPermission(this.currentUser.id, perm.permission));
        if (response.data) {
          return {
            icon: perm.icon,
            label: this.translateService.instant(perm.label),
            route: perm.route
          };
        }
        return null; // Return null if permission is denied
      });

      const results = await Promise.all(featurePromises);
      this.features = results.filter((feature) => feature !== null); // Filter out null entries
    } catch (error) {
      console.error('Error fetching permissions:', error);
    }
  }


  close() {
    this.popoverRef.close();
  }
  // features: MegaMenuFeature[] = [
  //   {
  //     icon: 'mat:layers',
  //     label: 'Dashboard',
  //     route: '/'
  //   },
  //   {
  //     icon: 'mat:assignment',
  //     label: 'AIO-Table',
  //     route: '/apps/aio-table'
  //   },
  //   {
  //     icon: 'mat:contact_support',
  //     label: 'Help Center',
  //     route: '/apps/help-center'
  //   },
  //   {
  //     icon: 'mat:contacts',
  //     label: 'Contacts',
  //     route: '/apps/contacts/grid'
  //   },
  //   {
  //     icon: 'mat:assessment',
  //     label: 'Scrumboard',
  //     route: '/apps/scrumboard/1'
  //   },
  //   {
  //     icon: 'mat:book',
  //     label: 'Documentation',
  //     route: '/documentation'
  //   }
  // ];

  // pages: MegaMenuPage[] = [
  //   {
  //     label: 'All-In-One Table',
  //     route: '/apps/aio-table'
  //   },
  //   {
  //     label: 'Authentication',
  //     route: '/login'
  //   },
  //   {
  //     label: 'Components',
  //     route: '/ui/components/overview'
  //   },
  //   {
  //     label: 'Documentation',
  //     route: '/documentation'
  //   },
  //   {
  //     label: 'FAQ',
  //     route: '/pages/faq'
  //   },
  //   {
  //     label: 'Form Elements',
  //     route: '/ui/forms/form-elements'
  //   },
  //   {
  //     label: 'Form Wizard',
  //     route: '/ui/forms/form-wizard'
  //   },
  //   {
  //     label: 'Guides',
  //     route: '/pages/guides'
  //   },
  //   {
  //     label: 'Help Center',
  //     route: '/apps/help-center'
  //   },
  //   {
  //     label: 'Scrumboard',
  //     route: '/apps/scrumboard'
  //   }
  // ];

  
}
